export default __webpack_public_path__ + "static/media/pictogramBeaconPieGraph64.c0fee0bc.svg";